// タグの属性の読み取り（Issue #46）。
//
//   <div data-wu-widget="receipt-issue"
//        data-descriptions="商品代金,PP袋代,ブックカバー代,台紙代金,マスク代,商品代"
//        data-top-url="https://www.anshinya.com/"></div>
//
// ★guid は属性ではなく URL のクエリ（?guid=）から読む。
//   お客様の発送完了メールに入っている URL がその形で、**送信済みのメールは書き換えられない**ため。

/**
 * 但し書きの既定値。
 * 全11店の選択肢の共通部分（どの店にも必ずこの2つが入っている）。
 * ★属性を書き忘れた店でも「商品代金」で発行できる状態にするための保険であって、
 *   正しい選択肢ではない。店ごとの選択肢は data-descriptions で渡す（Issue #46 の表）。
 */
export const DEFAULT_DESCRIPTIONS = ['商品代金', '商品代']

/**
 * 「TOPに戻る」の既定の飛び先。
 * ★ここだけは相対パスでよい。飛び先は店自身のトップで、ウィジェットが動いているのも店のページだから
 *   （API の絶対URL必須とは話が別。API は別オリジンなので相対にすると店を叩いてしまう）。
 */
export const DEFAULT_TOP_URL = '/'

/**
 * data-descriptions をカンマ区切りで分ける。
 * 前後の空白を落とし、空の項目と重複を捨てる。1つも残らなければ既定値。
 */
export function parseDescriptions(raw: string | undefined): string[] {
  const list: string[] = []
  for (const part of (raw ?? '').split(',')) {
    const v = part.trim()
    if (v === '') continue
    if (list.includes(v)) continue
    list.push(v)
  }
  return list.length > 0 ? list : DEFAULT_DESCRIPTIONS
}

/**
 * data-top-url。javascript: などを弾く。
 * ★店の管理画面から書かれる値なので攻撃経路ではないが、書き間違いを本番で踏むより安い。
 */
export function parseTopUrl(raw: string | undefined): string {
  const v = (raw ?? '').trim()
  if (v === '') return DEFAULT_TOP_URL

  // 相対パス（/ で始まる・./ ../ ・素の path）はそのまま通す。スキーム付きは http(s) のみ。
  if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(v)) return v
  return /^https?:/i.test(v) ? v : DEFAULT_TOP_URL
}

/** URL のクエリから guid を読む。空なら null。 */
export function readGuid(search: string): string | null {
  const v = new URLSearchParams(search).get('guid')
  const trimmed = (v ?? '').trim()
  return trimmed === '' ? null : trimmed
}
